import { useState } from 'react';
import { useTheme } from '@emotion/react';
import { bool, func } from 'prop-types';
import Modal from '../../shared/Modal';
import Button from '../../shared/Button';
import { Box, Stack, Flex } from '../../shared/layouts';
import Input from '../../shared/Input';
import AddIcon from 'imagesUwKluis/svg/addfill.svg';
import axios from 'axios';
import { useMediaQuery } from '@dnhb/node_package';
import {useTranslation} from "react-i18next";

const TwoFactorAuthActivateModal = ({ isOpen, onRequestClose, onBtnClick, onSecondaryBtnClick }) => {
  const { t } = useTranslation();
  const { breakpoints } = useTheme();
  const [hasError, setHasError] = useState(false);
  const isMobileModal = useMediaQuery(
    `(max-width: ${breakpoints.md ?? '604px'})`
  );
  const [code, setCode] = useState(Array(6).fill(''));

  const handleSubmit = (event) => {
    event.preventDefault();
    setHasError(false);
    axios
      .post('/user/settings/multifactor/otp/verify', {
        verify_otp: code.join(''),
      })
      .then(() => {
        onBtnClick();
        setCode(Array(6).fill(''));
      })
      .catch(({ response }) => {
        if (response.status === 400) {
          return setHasError(true);
        }

        window.alert(t('Er is iets mis gegaan'));
      });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        setHasError(false);
        onRequestClose();
      }}
      minWidth="554px"
      showProgressBar
      progressBarValue={3}
      progressBarTotal={6}
    >
      <Stack space="l" as="form" onSubmit={(event) => handleSubmit(event)}>
        <Flex alignItems="center" flexDirection="column" marginTop="40px">
          <AddIcon
            width="130px"
            height="130px"
            css={(theme) => ({
              fill: theme?.colors?.primary || 'blue',
              display: 'block',
              margin: '10px 0',
            })}
          />
          <Box fontScale="xl" fontWeight="bold" margin="20px 0">
            {t('Voer je code in')}
          </Box>
          <Box textAlign="center" marginBottom="20px">
            {t('Je hebt je account bijna beschermd!')}
            <br />
            {t('Voer de code in uit je authenticatie-app.')}
          </Box>
        </Flex>
        <Box
          flex={1}
          bg="background"
          m={{ mobile: '0 -16px', md: '0 -32px' }}
          p={{ mobile: '8px 16px', md: '24px 120px' }}
          maxWidth={'unset'}
        >
          {hasError && (
            <Box
              fontScale="m"
              fontWeight="bold"
              textAlign="center"
              css={({ colors }) => ({ color: colors.alert })}
            >
              {t('Ingevoerde code is incorrect')}
            </Box>
          )}
          <Flex
            bg="background"
            py="l"
            justifyContent="center"
            alignItems="center"
            m={{ mobile: '16px -16px', md: '32px -32px' }}
            css={{
              '> * + *': {
                marginLeft: '16px',
              },
            }}
          >
            {!isMobileModal &&
              code.map((value, i) => (
                <Input
                  key={i}
                  value={value}
                  maxLength={1}
                  errors={hasError}
                  css={{
                    width: '40px',
                    '> input': {
                      textAlign: 'center',
                    },
                  }}
                  onChange={(e) => {
                    const nextInput = e.target.parentElement.nextSibling;
                    setCode([
                      ...code.slice(0, i),
                      e.target.value,
                      ...code.slice(i + 1),
                    ]);
                    if (!value && nextInput) nextInput.children[0].focus();
                  }}
                  onKeyDown={({ key, target }) => {
                    if (
                      key === 'Backspace' &&
                      target.selectionStart === 0 &&
                      target.selectionEnd === 0
                    ) {
                      const previousInput =
                        target.parentElement.previousSibling;
                      if (previousInput) previousInput.children[0].focus();
                    }
                  }}
                />
              ))}
            {isMobileModal && (
              <Input
                value={code.join('')}
                maxLength={6}
                errors={hasError}
                css={{
                  '> input': {
                    textAlign: 'center',
                  },
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  setCode(value.split(''));
                }}
              />
            )}
          </Flex>
        </Box>
          {onSecondaryBtnClick ? (
            <Flex justifyContent="space-between">
              <Button variant="primary-outline" onClick={() => onSecondaryBtnClick()}>{t('Terug')}</Button>
              <Button type="submit">{t('Activeren')}</Button>
            </Flex>
          ) : (
            <Flex justifyContent="flex-end">
              <Button type="submit">{t('Activeren')}</Button>
            </Flex>
          )}
      </Stack>
    </Modal>
  );
};

TwoFactorAuthActivateModal.propTypes = {
  isOpen: bool,
  onRequestClose: func,
  onBtnClick: func,
};

TwoFactorAuthActivateModal.defaultProps = {
  isOpen: false,
  onRequestClose: () => {},
  onBtnClick: () => {},
};

export default TwoFactorAuthActivateModal;
